import { render, staticRenderFns } from "./MyDormRoomType.vue?vue&type=template&id=65577756&scoped=true&"
import script from "./MyDormRoomType.vue?vue&type=script&lang=js&"
export * from "./MyDormRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65577756",
  null
  
)

export default component.exports